<template>
  <div class="row">
    <div class="right-fixed" ref="mobileInner" v-show="numMove!=0" :class="isShowMenu?'rightMoveIn':'rightMoveOut'">
      <div class="right-fixed-Inner">
        <div class="right-fixedImg">
          <img src="../images/line5.png" />
        </div>
        <div class="pull-right pull-rightJia">
          <a class="menu-icon menu-iconPouUp" v-on:click="closeMenu()">
            <i class="icon-close"></i>
          </a>
        </div>
        <div class="tabPopUp-one" v-if="!isShowLogin">
          <div class="view-Comments Bold">{{$t('message.View Comments')}}</div>
          <div class="comments-btnPlace">
            <div class="comments-btn Bold" @click="goLogin">{{$t('message.Log in Facebook to view comments')}}</div>
          </div>
        </div>
        <div class="tabPopUp-two" v-if="isShowLogin">
          <div class="view-Comments Bold">View-Comments</div>
          <div class="comments-select-include">
            <div class="Bold">{{commentList.length}} Comment</div>
            <div class="comments-select">
              <div class="comments-select-sort Bold">Sort by</div>
              <select>
                <option value="volvo">Volvo</option>
                <option value="saab">Saab</option>
                <option value="mercedes">Mercedes</option>
                <option value="audi">Audi</option>
              </select>
            </div>
          </div>
          <div v-for="comment in commentList">
            <div class="item-table" >
              <div class="tdcell " style="width:45px;">
                <div class="studyImg">
                  <img src="../images/area of study.png" alt />
                </div>
              </div>
              <div class="tdcell">
                <div class="comments-info-name Bold">Chan Siu Ming</div>
                <div class="comments-info-description Regular">{{comment.message}}</div>
              </div>
            </div>
              <div class="item-table" style="padding-left:45px;" v-for="childC in comment.childComment">
                <div class="tdcell "  style="width:45px;">
                  <div class="studyImg">
                    <img src="../images/area of study.png" alt />
                  </div>
                </div>
                <div class="tdcell">
                  <div class="comments-info-name Bold">Chan Siu Ming</div>
                  <div class="comments-info-description Regular">{{childC.message}}</div>
                </div>
              </div>
          </div>
          <div class="facebook-comments Bold">Facebook Comments Plugin</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowMenu: false,
      isShowLogin: false,
      numMove:0,
      commentList:[],
      isComment:false,
    };
  },
  props: ["logGaEvent",'postid'],
  computed: {
    innerwidth() {
      return this.$store.state.innerWidth;
    }
  },
  methods: {
    showMenu:function() {
       
      this.numMove++;
      this.isShowMenu = true;
      // this.isShowLogin = false;
      this.overflowY();
     
    
      this.addMobileInner();
      
    },
    addMobileInner:function(){
       this.$refs.mobileInner.style.height = window.innerHeight + "px";
    },
    cutMobileInner:function(){
       this.$refs.mobileInner.style.height = 0 + "px";
    },
    closeMenu: function() {
      this.isShowMenu = false;
      this.$parent.showPoState();
      this.$parent.hideMobid();
      this.$parent.changeContentShowFoorter();
      this.freedOverflowY();
      this.$parent.changeScrollTop();
    },
    goLogin: function() {
      var that = this;
      FB.login(function(response) {
        if (response.authResponse) {
          FB.api("/me", function(response) {
            that.isShowLogin = true;
            that.getComment();
          });
        } else {
        }
      });
    },
    getComment: function() {
      var that = this;
      if(this.isComment||!this.postid) return;
      this.isComment = true
      setTimeout(function(){
        that.isComment = false
      },1000)
        // e.authResponse.accessToken
        FB.api("/v5.0/105781324163255_"+this.postid+"/comments", 
          function(response) {
            this.isComment = false;
            if (response && !response.error) {
              that.commentList = response.data;
              for(var i=0;i<that.commentList.length;i++){
                that.getReplyComment(that.commentList[i])
              }
            }
          }
        );
    },
    getReplyComment:function(obj){
      var that = this;
        // e.authResponse.accessToken
        FB.api("/v5.0/"+obj.id+"/comments", 
          function(response) {
            if (response && !response.error) {
              obj.childComment = response.data;
            }
          }
        );
    },
    checkWidth: function() {
      this.$refs.mobileInner.style.height = window.innerHeight + "px";
    
      this.$parent.showMobid();
      this.numMove == 0?this.$parent.hideMobid():'';

      document.body.style.height = window.innerHeight + "px";
 
   
    },
    setHight: function() {
      this.$refs.mobile.style.height = window.innerHeight + "px";
      this.$refs.mobileContent.style.height = window.innerHeight + "px";
    },
    overflowY: function() {},
    freedOverflowY: function() {
      document.body.style.overflow = "auto";
    }
  },

  mounted() {
    FB.init({
      appId: "464396634378358",
      xfbml: true,
      version: "v2.7"
    });
    var that = this;
    setTimeout(function(){
      FB.getLoginStatus(function(response) {
        // 
        if (response.authResponse) {
          that.isShowLogin = true;
          that.getComment();
        }
      })
    })
    if(this.isShowMenu == true){
        this.$refs.mobileInner.style.height = window.innerHeight + "px";
        
    }else{
          this.$refs.mobileInner.style.height = 0 + "px";
    }
  },
  watch: {
    innerwidth(news, old) {
      this.checkWidth();
       if(this.isShowMenu == true){
          this.$refs.mobileInner.style.height = window.innerHeight + "px";
          
        }else{
            this.$refs.mobileInner.style.height = 0 + "px";
            this.$parent.hideMobid();
        }
    },
    postid(n,o){
      if(this.isShowLogin&&this.postid){
        this.getComment();
      }
    },
    isShowLogin(n,o){
      if(this.isShowLogin&&this.postid){
        this.getComment();
      }
    }
  }
};
</script>